import {
  BarChart3,
  LogOut,
  Receipt,
  Settings,
  Users,
} from 'lucide-react';

import { Sheet } from '@/components/Sheet';
import { cn } from '@/lib/cn';
import { OVERFLOW_VIEWS, VIEW_LABELS, type View } from '@/lib/views';

const ICONS = {
  clients: <Users size={18} strokeWidth={1.5} aria-hidden />,
  reports: <BarChart3 size={18} strokeWidth={1.5} aria-hidden />,
  billing: <Receipt size={18} strokeWidth={1.5} aria-hidden />,
  settings: <Settings size={18} strokeWidth={1.5} aria-hidden />,
} as const;

interface Props {
  open: boolean;
  onClose: () => void;
  activeView: View;
  onSelectView: (view: View) => void;
  onSignOut: () => void;
}

/** Overflow destinations + sign out for the mobile More tab. */
export function MoreNavSheet({
  open,
  onClose,
  activeView,
  onSelectView,
  onSignOut,
}: Props) {
  if (!open) return null;

  return (
    <Sheet title="More" onClose={onClose}>
      <ul className="flex flex-col gap-1">
        {OVERFLOW_VIEWS.map((id) => {
          const active = activeView === id;
          return (
            <li key={id}>
              <button
                type="button"
                aria-current={active ? 'page' : undefined}
                onClick={() => {
                  onSelectView(id);
                  onClose();
                }}
                className={cn(
                  'pressable flex min-h-touch w-full items-center gap-3 rounded-lg px-3 text-body',
                  'transition-colors duration-press',
                  active
                    ? 'bg-surface-2 font-medium text-text'
                    : 'text-text-secondary hover:bg-surface-2 hover:text-text',
                )}
              >
                <span className="flex size-action shrink-0 items-center justify-center" aria-hidden>
                  {ICONS[id as keyof typeof ICONS]}
                </span>
                <span className="min-w-0 flex-1 truncate">{VIEW_LABELS[id]}</span>
              </button>
            </li>
          );
        })}

        <li className="mt-2 border-t border-border pt-2">
          <button
            type="button"
            onClick={() => {
              onSignOut();
              onClose();
            }}
            className={cn(
              'pressable flex min-h-touch w-full items-center gap-3 rounded-lg px-3 text-body',
              'text-danger hover:bg-danger-quiet',
            )}
          >
            <span className="flex size-action shrink-0 items-center justify-center" aria-hidden>
              <LogOut size={18} strokeWidth={1.5} aria-hidden />
            </span>
            Sign out
          </button>
        </li>
      </ul>
    </Sheet>
  );
}
